<template>
  <div id="cmop_login">
    <div class="main">
      <div class="tips">为充分保障您的权益，您所采购的神州网信的授权许可(SN)并未开放激活，您需要使用以下信息在线提交申请，我们会在第二个工作日为您开放激活</div>
      <el-form label-position="right" :rules="rules" ref="ruleForm" label-width="80px" :model="formData" size="small">
        <el-form-item label="客户名称" prop="customer_name">
          <el-input v-model="formData.customer_name" placeholder="请输入下单时的客户全称"></el-input>
        </el-form-item>
        <el-form-item label="订单编号" prop="order_number">
          <el-input v-model="formData.order_number" placeholder="请输入下单时的订单编号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="formData.code" placeholder="请输入右侧验证码" style="width:74%;"></el-input>
          <el-button size="small" type="primary" @click="createCode" class="generate_code">{{g_code}}</el-button>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="formData.contact"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone_number">
          <el-input v-model="formData.phone_number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { post } from '@/util/http';
export default {
  name: 'cmop_login',
  data() {
    var checkTele = (rule, value, callback) => {
        if(!value) {
          callback();
        }
        var mobileReg = /^1[34578]\d{9}$/;
        var teleReg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
        if (mobileReg.test(value) || teleReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的电话号码'));
        }
      };
    var contact = (rule, value, callback) => {
          callback();
      };
    var checkEmail = (rule, value, callback) => {
        if(!value) {
          callback();
        }
        var emailReg =  /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (emailReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱格式'));
        }
      };
    var checkCode = (rule, value, callback) => {
        if(value.toUpperCase() != this.g_code) {
          callback(new Error('请输入正确的验证码'))
        } else {
          callback();
        }
      };
    return {
      g_code: '', //生成的验证码
      formData: {
          customer_name: '',
          order_number: '',
          contact: '',
          email: '',
          phone_number: '',
          code: ''
        },
        rules: {
          customer_name: [
            {required: true, message: '请输入下单时的客户全称', trigger: 'blur'}
          ],
          order_number: [
            {required: true, message: '请输入下单时的订单编号', trigger: 'blur'}
          ],
          code: [
            {required: true, validator: checkCode, trigger: 'blur'}
          ],
          phone_number: [
            {validator: checkTele, trigger: 'blur'}
          ],
          contact: [
            {validator: contact, trigger: 'blur'}
          ],
          email: [
            {validator: checkEmail, trigger: 'blur'}
          ]
        }
    };
  },
  created(){
    this.createCode();
  },
  methods: {
    // 图片验证码
    createCode(){
        let code = "";
        let codeLength = 4;//验证码的长度
        let random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
                    'S','T','U','V','W','X','Y','Z');//随机数
        for(var i = 0; i < codeLength; i++) {
            //循环操作
            var index = Math.floor(Math.random()*36);//取得随机数的索引（0~35）
            code += random[index];//根据索引取得随机数加到code上
        }
        this.g_code = code;//把code值赋给验证码
    },
    submitForm(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          post("ecla/authenticate/", _this.formData).then( res => {
            if (res.status === 3) {
              _this.$notify.success({
                  message: res.msg,
                  offset:70
              });
            } else {
              _this.$router.push({name: "cmopDetail", params: { status: res.status, token: res.token, order_type: res.order_type }});
            }
          }, err => {
            _this.createCode();
            _this.formData.code = '';
            _this.$notify.error({
                message: err.data.msg,
                offset:70
            });
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cmop/CmopLogin.vue